
    <!--
 * 页面-iframe
 * @LastEditTime: Fri Jan 10 2025 16:12:56 GMT+0800 (中国标准时间)
 -->
 <template>
  <iframe id="u_c_YFC217"  :src="compData.href" :class="[`normal`,`u_c_YFC217`]" ></iframe>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";


    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"href":""},"zh-CN":{"href":""}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['zh-CN']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = 'iframe';

    // 自定义setup - 开始
    compData.href = `https://auto-page.${utils.getMainHost()}/${utils.getUrlParams("aid")}/${window.location.search}`;
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_YFC217.normal{
position:relative;
height:100%;
border:none;
width:39.06vw;

}
}.zh-CN{
.u_c_YFC217.normal{
position:relative;
height:100%;
border:none;
width:39.06vw;

}
}
</style>
